import React from 'react';
import styles from './NotificationBadge.module.css';

export type NotificationBadgeVariant = 'dot' | 'count' | 'max';

interface NotificationBadgeProps {
  variant: NotificationBadgeVariant;
  count?: number;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  variant,
  count = 3,
}) => {
  switch (variant) {
    case 'dot':
      return <span className={styles.dot} />;
    case 'count':
      return <span className={styles.count}>{count}</span>;
    case 'max':
      return <span className={styles.max}>99+</span>;
  }
};

export default NotificationBadge;
